import { getPeriodBoundsFromYear } from '@/interfaces/Building.interface';
import { type Actions, ActionType } from './buildings-comparison.actions';
import { initialState, type State } from './buildings-comparison.state';

export function buildingsComparisonReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.LOAD_STATE: {
            return state;
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        case ActionType.SET_COMPARISON: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    ...action.payload.comparison
                }
            };
        }

        case ActionType.SET_COMPARISON_AXIS: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    xAxis: action.payload.xAxis,
                    yAxis: action.payload.yAxis
                }
            };
        }

        case ActionType.SET_COMPARISON_X_AXIS: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    xAxis: action.payload.axis
                }
            };
        }

        case ActionType.SET_COMPARISON_Y_AXIS: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    yAxis: action.payload.axis
                }
            };
        }

        case ActionType.SET_PERIOD: {
            const period = getPeriodBoundsFromYear(action.payload.year);
            return {
                ...state,
                period
            };
        }

        case ActionType.SET_RANKING_INDICATOR: {
            return {
                ...state,
                ranking: {
                    ...state.ranking,
                    axis: action.payload.axis
                }
            };
        }

        case ActionType.SET_AVERAGE_ABSCISSA: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    averageAbscissaEnabled: action.payload.value
                }
            };
        }

        case ActionType.SET_AVERAGE_ORDINATE: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    averageOrdinateEnabled: action.payload.value
                }
            };
        }

        case ActionType.SET_LINEAR_REGRESSION: {
            return {
                ...state,
                comparison: {
                    ...state.comparison,
                    linearRegressionEnabled: action.payload.value
                }
            };
        }

        default: {
            return state;
        }
    }
}
